module.exports = {
  "/": {
    "name": "campaignListPage",
    "success": {
      "default": [
        "CAMPAIGN_LIST_PAGE",
        "CAMPAIGNS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    },
    "error": [
      "CAMPAIGNS_PAGE_FAILURE"
    ]
  },
  "/drafts": {
    "name": "draftsList",
    "success": {
      "default": [
        "DRAFTS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/sequences": {
    "name": "sequencesList",
    "success": {
      "sequencesList": [
        "SEQUENCES_TABLE_LOADED"
      ],
      "emptyState": [
        "SEQUENCES_EMPTY_STATE"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/sequences/:sequenceId": {
    "name": "sequencesDetails",
    "success": {
      "default": [
        "SEQUENCES_DETAILS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/sequences/:sequenceId/manage/:network/:accountId/campaigns/:campaignId": {
    "name": "sequences-campaign-list-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/sequences/:sequenceId/accounts/:network/:accountId/campaigns/:campaignId": {
    "name": "sequence-campaign-details",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_LOADED",
        "CAMPAIGN_DETAILS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/sequences/:sequenceId/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId": {
    "name": "sequence-campaign-details-adgroup",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_LOADED",
        "CAMPAIGN_DETAILS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/sequences/:sequenceId/accounts/:network/:accountId/campaigns/:campaignId/manage": {
    "name": "sequence-campaign-details-manage",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/sequences/:sequenceId/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/manage": {
    "name": "sequence-campaign-details-adgroup-manage",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/sequences/:sequenceId/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/ads/:adId/manage": {
    "name": "sequence-campaign-details-ad-manage",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/onboarding": {
    "name": "emptyState",
    "success": {
      "default": [
        "EMPTY_STATE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/onboarding-wizard": {
    "name": "onboardingWizard",
    "success": {
      "default": [
        "ONBOARDING_STEP_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/onboarding-wizard/select-accounts": {
    "name": "onboardingSelectAccounts",
    "success": {
      "default": [
        "SELECT_ACCOUNTS_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/onboarding-wizard/pixel-tracking": {
    "name": "onboardingPixelTracking",
    "success": {
      "default": [
        "PIXEL_TRACKING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/onboarding-wizard/roi-calculation": {
    "name": "onboardingRoiCalculation",
    "success": {
      "default": [
        "ROI_CALCULATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/onboarding-wizard/lead-syncing": {
    "name": "onboardingLeadSyncing",
    "success": {
      "default": [
        "LEAD_SYNCING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/audiences": {
    "name": "audiences",
    "success": {
      "default": [
        "AUDIENCES_PAGE",
        "AUDIENCES_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/audiences/:audienceId": {
    "name": "audiencePanel",
    "success": {
      "default": [
        "AUDIENCES_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    },
    "error": [
      "AUDIENCES_PANEL_FAILURE"
    ]
  },
  "/events": {
    "name": "events",
    "success": {
      "default": [
        "EVENTS_PAGE",
        "EVENTS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/events/:eventId": {
    "name": "eventPanel",
    "success": {
      "default": [
        "EVENT_PANEL_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/dashboard": {
    "name": "analyze",
    "success": {
      "default": [
        "CAMPAIGNS_DASHBOARD_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId": {
    "name": "campaign-details",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_LOADED",
        "CAMPAIGN_DETAILS_TABLE_LOADED",
        "DEFAULT_CONTROL_BUTTON_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/analyze": {
    "name": "campaign-details-analyze",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_TABS",
        "CAMPAGIN_DETAILS_BREAKDOWN_CHART",
        "DEFAULT_CONTROL_BUTTON_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/optimize": {
    "name": "campaign-details-optimize",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_OPTIMIZE"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId": {
    "name": "campaign-details-adgroup",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_LOADED",
        "CAMPAIGN_DETAILS_TABLE_LOADED",
        "DEFAULT_CONTROL_BUTTON_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/keywords": {
    "name": "campaign-details-keywords",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_LOADED",
        "CAMPAIGN_DETAILS_TABLE_LOADED",
        "DEFAULT_CONTROL_BUTTON_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/keywords/:keywordId/manage": {
    "name": "campaign-details-keywords-edit",
    "success": {
      "default": [
        "KEYWORD_EDITING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/negative-keywords": {
    "name": "campaign-details-negative-keywords",
    "success": {
      "default": [
        "CAMPAIGN_DETAILS_LOADED",
        "CAMPAIGN_DETAILS_TABLE_LOADED",
        "DEFAULT_CONTROL_BUTTON_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/manage/:network/:accountId/campaigns/:campaignId": {
    "name": "campaign-list-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/manage-campaign": {
    "name": "campaign-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/manage": {
    "name": "adgroup-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/manage-campaign": {
    "name": "adgroup-campaign-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/ads/:adId/manage": {
    "name": "ad-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    },
    "error": [
      "ENTITY_MANAGEMENT_PANEL_FAILURE"
    ]
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/keywords/manage-campaign": {
    "name": "campaign-details-keyword-campaign-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/negative-keywords/manage-campaign": {
    "name": "campaign-details-keyword-campaign-management",
    "success": {
      "default": [
        "ENTITY_MANAGEMENT_PANEL"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/adwords/:accountId/campaigns/:campaignId/settings/locations": {
    "name": "adwords-campaign-settings-geos",
    "success": {
      "default": [
        "ADWORDS_CAMPAIGN_SETTINGS_GEOS"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/adwords/:accountId/campaigns/:campaignId/settings/networks": {
    "name": "adwords-campaign-settings-networks",
    "success": {
      "default": [
        "ADWORDS_CAMPAIGN_SETTINGS_NETWORKS"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/adwords/:accountId/campaigns/:campaignId/settings/languages": {
    "name": "adwords-campaign-settings-languages",
    "success": {
      "default": [
        "ADWORDS_CAMPAIGN_SETTINGS_LANGUAGES"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/adwords/:accountId/campaigns/:campaignId/settings/negative-keywords": {
    "name": "adwords-campaign-settings-negative-keywords",
    "success": {
      "default": [
        "ADWORDS_CAMPAIGN_SETTINGS_NEGATIVE_KEYWORDS"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/accounts/adwords/:accountId/campaigns/:campaignId/settings/bid-strategy-and-budget": {
    "name": "adwords-campaign-settings-bid-strategy-and-budget",
    "success": {
      "default": [
        "ADWORDS_CAMPAIGN_SETTINGS_DAILY_BUDGET",
        "ADWORDS_CAMPAIGN_SETTINGS_BIDDING_STRATEGIES"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ],
      "missing adAccount page loaded": [
        "NO_AD_ACCOUNT_PAGE_LOADED"
      ]
    }
  },
  "/campaigns/new": {
    "name": "adCreationWelcome",
    "success": {
      "default": [
        "AD_CREATION_WELCOME_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/new/:adCreationType": {
    "name": "adCreationWelcomeWithType",
    "success": {
      "default": [
        "AD_CREATION_WELCOME_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/new/:adCreationType/:network": {
    "name": "adCreationWelcomeWithTypeAndNetwork",
    "success": {
      "default": [
        "AD_CREATION_WELCOME_LOADED",
        "AD_CREATION_WELCOME_OPTIONS"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/sequence/new/:ad/:step": {
    "name": "adSequenceCreation",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/:adCreationType/new": {
    "name": "leadAdCreation",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/:adCreationType/new/:step": {
    "name": "leadAdCreationStep",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/:adCreationType/new/:step/:index": {
    "name": "leadAdCreationStepIndex",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/:adCreationType/drafts/:draftId": {
    "name": "leadAdCreationDraft",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/:adCreationType/drafts/:draftId/:step": {
    "name": "leadAdCreationDraftStep",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/:adCreationType/drafts/:draftId/:step/:index": {
    "name": "leadAdCreationDraftStepIndex",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/create-adwords-search-campaign/landing-page": {
    "name": "searchCampaignCreationLandingPage",
    "success": {
      "default": [
        "ADWORDS_SEARCH_CAMPAIGN_CREATION_LANDING_PAGE"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/create-adwords-search-campaign/ad": {
    "name": "searchCampaignCreationAd",
    "success": {
      "default": [
        "ADWORDS_SEARCH_CAMPAIGN_CREATION_AD"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/create-adwords-search-campaign/keywords": {
    "name": "searchCampaignCreationKeywords",
    "success": {
      "default": [
        "ADWORDS_SEARCH_CAMPAIGN_CREATION_KEYWORDS"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/create-adwords-search-campaign/geography": {
    "name": "searchCampaignCreationGeography",
    "success": {
      "default": [
        "ADWORDS_SEARCH_CAMPAIGN_CREATION_GEOGRAPHY"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/create-adwords-search-campaign/budget": {
    "name": "searchCampaignCreationBudget",
    "success": {
      "default": [
        "ADWORDS_SEARCH_CAMPAIGN_CREATION_BUDGET"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/create-adwords-search-campaign/review": {
    "name": "searchCampaignCreationReview",
    "success": {
      "default": [
        "ADWORDS_SEARCH_CAMPAIGN_CREATION_REVIEW"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/accounts": {
    "name": "fbSetupAccounts",
    "success": {
      "default": [
        "FB_CRM_ACCOUNTS_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/connecting": {
    "name": "fbSetupConnecting",
    "success": {
      "default": [
        "FB_CRM_CONNECTING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/success": {
    "name": "fbSetupSuccess",
    "success": {
      "default": [
        "FB_CRM_SUCCESS_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/error": {
    "name": "fbSetupError",
    "success": {
      "default": [
        "FB_CRM_ERROR_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/goToSettings": {
    "name": "fbSetupGoToSettings",
    "success": {
      "default": [
        "FB_CRM_GO_TO_SETTINGS_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/recommendations": {
    "name": "recommendations",
    "success": {
      "default": [
        "RECOMMENDATIONS_LIST_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/:network/:networkId/campaigns/:campaignId/edit/:step": {
    "name": "editCampaign",
    "success": {
      "default": [
        "AD_EDITING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/:network/:networkId/campaigns/:campaignId/adgroups/:adGroupId/edit/:step": {
    "name": "editAdGroup",
    "success": {
      "default": [
        "AD_EDITING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/:network/:networkId/campaigns/:campaignId/adgroups/:adGroupId/ad/:adId/edit/:step": {
    "name": "editAd",
    "success": {
      "default": [
        "AD_EDITING_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/campaigns/:network/sequence/edit/:ad/:step": {
    "name": "editSequence",
    "success": {
      "default": [
        "AD_CREATION_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  },
  "/goals": {
    "name": "goals",
    "success": {
      "default": [
        "GOALS_TABLE_LOADED"
      ],
      "adblocker page loaded": [
        "ADBLOCK_ERROR_PAGE"
      ],
      "no ads access": [
        "NO_ADS_ACCESS"
      ]
    }
  }
};